module.exports = __webpack_public_path__ + "static/img/pointer.7d7a265b.png";